export const AUTH_URL = process.env.REACT_APP_AUTH_URL + "/auth";
export const AI_CHAT_URL = process.env.REACT_APP_AUTH_URL;
export const AI_SOW_CHAT_URL = process.env.REACT_APP_AI_CHAT_URL;
export const ENTERPRISE_AI_URL =
  process.env.REACT_APP_ENTERPRISE_AI_URL || process.env.REACT_APP_AUTH_URL;
export const ADMIN_URL = process.env.REACT_APP_ADMIN_URL;
export const MEMBER_URL = process.env.REACT_APP_MEMBER_URL;
export const PROJECT_URL = process.env.REACT_APP_PROJECT_URL;
export const REPORT_URL = process.env.REACT_APP_REPORT_URL + "/report/summary";
export const REPORT_URL_ONE = process.env.REACT_APP_REPORT_URL + "/report";
export const OKR_URL = process.env.REACT_APP_OKR_URL;
export const REMINDER_URL = process.env.REACT_APP_REMINDER_URL;
export const INVOICE_URL = process.env.REACT_APP_INVOICE_URL;
export const TIMEOFF_URL = process.env.REACT_APP_TIMEOFF_URL;
export const EXPENSE_URL = process.env.REACT_APP_EXPENSE_URL;
export const SUPERADMIN_URL = process.env.REACT_APP_SUPERADMIN_URL;
export const SUPERADMIN_PRICING_URL =
  process.env.REACT_APP_SUPERADMIN_PRICING_URL;
export const NUDGES_URL = process.env.REACT_APP_NUDGES_URL;
export const HANDBOOK_URL = process.env.REACT_APP_HANDBOOK;
export const STRIPE_URL = process.env.REACT_APP_STRIPE_URL;
export const STRIPE_URL_ONE = process.env.REACT_APP_STRIPE_URLONE;
export const STRIPE_SUCCESS_URL = process.env.REACT_APP_STRIPE_SUCCESS_URL;
export const STRIPE_CANCEL_URL = process.env.REACT_APP_STRIPE_CANCEL_URL;
export const STRIPE_BACK_URL = process.env.REACT_APP_STRIPE_BACK_URL;
export const CULTURALFIT = process.env.REACT_APP_CULTURE_URL;
export const HELPDESK_URL = process.env.REACT_APP_HELPDESK;
export const TODOS_URL = process.env.REACT_APP_TODOS_URL;
export const OKR_INGEST = process.env.REACT_APP_OKR_INGEST;
export const STRATEGY_BUILDER = process.env.REACT_APP_STRATEGY_BUILDER;
export const ALLOCATION_URL = process.env.REACT_APP_ALLOCATION_URL;
export const DEVOPS_URL = process.env.REACT_APP_DEVOPS_AMLY_API_URL;
